export default "__VITE_ASSET__f6138df5__"